module.exports = __webpack_public_path__ + "static/media/boonedam.a6448d12.png";